import "./index.css";
import React from "react";
import { UR_Owner } from "State";
import { checkAccess } from "Auth";
import Rows from "components/Rows";
import Address from "components/Address";
import { Form, Input, Switch } from "antd";
import StepHeader from "./StepHeader";

import type { TypePersonalInfoProps } from "./PersonalInfo";

interface TypeCompanyDetailsProps extends TypePersonalInfoProps {}

type TypeCompanyDetailsComp = React.FC<TypeCompanyDetailsProps> & {
  REQUIRED: typeof FORM_REQUIRED_FIELDS;
};

const IS_OWNER = checkAccess([UR_Owner]);

// address 只有 "organization" 拥有者才可以配置，所以这里的校验是根据身份动态校验的
const FIELDS_ADDRESS_CONFIG = IS_OWNER
  ? {
      zip: ["LandingPageSetUp", "CompanyZip"],
      city: ["LandingPageSetUp", "CompanyCity"],
      state: ["LandingPageSetUp", "CompanyState"],
      county: ["LandingPageSetUp", "CompanyCounty"],
      street: ["LandingPageSetUp", "CompanyAddress"],
    }
  : {};

// 必填的字段
const FORM_REQUIRED_FIELDS = {
  ...FIELDS_ADDRESS_CONFIG,
  CompanyName: ["LandingPageSetUp", "CompanyName"],
};

/**
 * @name CompanyDetails 公司详情
 */
const CompanyDetails: TypeCompanyDetailsComp = ({
  badge,
  intro,
  title = "Let's add your company details",
}) => (
  <div className="layout-profile-ctx">
    <StepHeader title={title} badge={badge} intro={intro} />

    <Form.Item
      initialValue
      label="COMPANY"
      layout="horizontal"
      valuePropName="checked"
      className="website-switch"
      name={["LandingPageSetUp", "showCompanyInfo"]}
    >
      <Switch />
    </Form.Item>

    <p className="website-form-desc">
      Show your company information on your personal website
    </p>

    <Rows span={12}>
      <Form.Item
        label="Company name"
        name={FORM_REQUIRED_FIELDS.CompanyName}
        rules={[
          {
            required: true,
            message: "Company name must not be empty",
          },
        ]}
      >
        <Input placeholder="Please enter company name" />
      </Form.Item>

      <Form.Item
        label="Company website"
        name={["LandingPageSetUp", "companyLink"]}
        rules={[{ type: "url", message: "Please enter a valid URL" }]}
      >
        <Input placeholder="Please enter the company website address" />
      </Form.Item>
    </Rows>

    <Form.Item label="Company slogan" name={["LandingPageSetUp", "banner"]}>
      <Input placeholder="Please enter company slogan" />
    </Form.Item>

    {/* 组织管理员才可以编辑 */}
    {IS_OWNER ? (
      <Address required fullAddress fieldNames={FIELDS_ADDRESS_CONFIG} />
    ) : null}

    <Form.Item
      label="Introduction"
      name={["LandingPageSetUp", "companyIntroduction"]}
    >
      <Input.TextArea rows={4} placeholder="Please enter introduction" />
    </Form.Item>
  </div>
);

CompanyDetails.REQUIRED = FORM_REQUIRED_FIELDS;

export default CompanyDetails;
